<script lang="ts">
  // Agent first: the instruction to give an agent so it connects to a pull
  // request (`changeling_connect`), and how to install the plugin.
  import { MOCK } from '../mock/flag';
  import { copyText } from '../clipboard';
  import { agentInstall } from '../logic/relayText';
  import RelayInstall from './RelayInstall.svelte';
  /** `titled`: with its own heading and introduction (false where its container gives them). */
  let { reviewUrl = '', titled = true }: { reviewUrl?: string; titled?: boolean } = $props();
  let url = $state('');
  let copied = $state(false);
  let error = $state('');
  const instruction = $derived(`Connect to Changeling PR ${reviewUrl || url || '[paste the Changeling pull request URL]'} with the changeling plugin. If it is not installed, ${agentInstall(location.origin)}, and tell me if you need a restart. Give me the agent fingerprint so I can confirm it in Changeling. Do not push or publish changes without my instruction.`);
  async function copy() {
    if (await copyText(instruction)) { copied = true; error = ''; } else error = 'Select and copy the instruction below.';
  }
</script>
<div class="relay-connect">
  {#if titled}<h3>Connect your agent</h3>{/if}
  {#if MOCK}<p>Agent connections are available in a signed-in Changeling instance.</p>
  {:else}
    {#if titled}<p>Give Claude Code or Codex this instruction. It opens a private link here, where you confirm the agent by its fingerprint and choose what it may read.</p>{/if}
    {#if !reviewUrl}<label>Changeling pull request URL <input type="url" bind:value={url} oninput={() => copied = false} placeholder="https://…/gh/owner/repo/pull/123" /></label>{/if}
    <textarea readonly value={instruction} rows="3" aria-label="Agent connection instruction"></textarea>
    <button class="btn small" onclick={copy}>{copied ? 'Copied — paste into your agent' : 'Copy connection instruction'}</button>
    <details><summary>Install the plugin yourself</summary><RelayInstall /></details>
    {#if error}<p role="alert">{error}</p>{/if}
  {/if}
</div>
<style>
  .relay-connect { display: grid; gap: 10px; font-size: 13px; }
  h3, p { margin: 0; }
  h3 { font-size: 14px; }
  label { display: grid; gap: 4px; color: var(--muted); font-size: 12px; }
  input, textarea { color: var(--fg); font-size: 13px; }
  input { background: var(--surface); border: 1px solid var(--line); border-radius: 6px; padding: 6px 8px; }
  textarea { min-height: 0; font: 12px/1.5 ui-monospace, SFMono-Regular, monospace; }
  .relay-connect > .btn { justify-self: start; }
  details > :global(.relay-install) { margin-top: 8px; }
</style>
